<template>
  <Page
    back="/menu"
    label="Enovis&#8482; MedEd Calendar"
    :filters="filters"
    :filtersOptions="filtersOptions"
    liveFilters
    :filtersLabels="filtersLabels"
    @onFiltersChange="updateFilters"
    @onFiltersQuery="previewFilters"
    @onFiltersClose="restoreFilters"
  >
    <document-list-item
      :flat="false"
      document-type="Product Doc"
      :document="stickyDocument"
      classes="my-8 px-8"
    />
    <ion-list class="bg-transparent">
      <div
        class="flex flex-row justify-between items-center bg-transparent pb-4 mb-2"
        v-for="(course, i) in list"
        :key="i"
        @click="routeTo(course)"
      >
        <div
          class="flex flex-start items-center pointer-events-none px-8 w-full"
        >
          <CourseCard :instance="course" />
        </div>
      </div>
    </ion-list>
    <div
      v-if="loaded && !list.length"
      class="flex flex-col justify-center items-center px-8 py-12 text-center"
    >
      <ion-img src="assets/icon/no-results.svg" class="mx-auto mb-8" />
      <span class="font-helvetica-bold text-20 spacing-2 line-28 mb-2"
        >No courses found</span
      >
      <span class="font-helvetica text-16 spacing-1 line-24 text-grey"
        >There are no courses matching the current filters. Try changing or
        resetting them.</span
      >
    </div>
  </Page>
</template>

<script>
import Page from "../../components/Page.vue";
import CourseCard from "../../components/learn/CourseCard.vue";
import { IonList, IonImg } from "@ionic/vue";
import messages from "@/messages";
import urls from "@/urls";
import DocumentListItem from "@/components/DocumentListItem.vue";

// Labels used by the public MedEd calendar, where they differ from filtersJson.
const FILTERS_LABELS = {
  category: { span: "Events categories", placeholder: "All categories" },
  typology: { placeholder: "All courses" },
  type_country: { span: "Local/International", placeholder: "All Types" },
  country: { placeholder: "All countries" },
  language: { placeholder: "All languages" },
  month: { placeholder: "All Months" },
  speaker: { placeholder: "All faculties" },
};

export default {
  components: {
    Page,
    IonList,
    IonImg,
    CourseCard,
    DocumentListItem,
  },

  data() {
    return {
      list: [],
      loaded: false,
      filtersOptions: {},
      filtersLabels: FILTERS_LABELS,
      filters: {
        year: new Date().getFullYear(),
      },
      stickyDocument: {
        label: "MedEd Booklet",
        link: "https://enovis-surgical.com/repo/transfers/946/Enovis_Medical_Education_Booklet.pdf",
        size: "11,6 MB",
      },
    };
  },

  created() {
    this.fetchCourses();
  },

  methods: {
    routeTo(item) {
      this.$router.push(`/learn/${item.id}`);
    },

    async fetchCourses(params = this.filters, loader = true) {
      try {
        const results = await this.$http({
          method: "GET",
          url: urls.learn.list,
          params,
          loader,
        });
        if (results) {
          this.list = results.list || [];
          this.filtersOptions = results.filters || {};
        }
      } catch (e) {
        console.error(e);
        this.$toast({
          message: messages.errors.learn,
          color: "danger",
        });
      } finally {
        this.loaded = true;
      }
    },

    // Done: commit the selection (updates the URL + refetches via the watcher).
    updateFilters(filters) {
      this.filters = filters;
    },

    // Live progressive preview while the modal is open: refetch quietly so the
    // dependent filters get repopulated, without committing the selection.
    previewFilters(filters) {
      this.fetchCourses(filters, false);
    },

    // Close: discard the preview and restore the applied selection.
    restoreFilters() {
      this.fetchCourses(this.filters, false);
    },
  },

  watch: {
    filters: function (newFilters) {
      this.$router.push({
        path: this.$route.path,
        query: newFilters,
      });
      this.fetchCourses(newFilters);
    },
  },
};
</script>
